import type { NoveltyCheckTaskStep } from '../../enums';
import type { NoveltyCheckStepInfo, NoveltyCheckStepInfoStatus } from '../../types';
import type { NoveltyCheckReportState } from './novelty-check-report-state';

export const NoveltyCheckReportContext = Symbol.for('NoveltyCheckReportContext');

/**
 * 新颖性检查报告(状态模式)上下文
 */
export interface NoveltyCheckReportContext {
    /**
     * 获取状态
     * @param step 状态步骤
     */
    getState(step: NoveltyCheckTaskStep): NoveltyCheckReportState;

    /**
     * 切换到指定状态
     * @param state 目标状态
     */
    transitionTo(state: NoveltyCheckReportState): Promise<void>;

    /**
     * 进入下一步
     */
    next(): Promise<void>;

    /**
     * 返回上一步
     */
    previous(): Promise<void>;

    /**
     * 恢复到指定状态
     * @param state 目标状态
     */
    restoreBack(state: NoveltyCheckReportState): Promise<void>;

    /**
     * 初始化报告
     */
    initialize(): Promise<void>;

    /**
     * 处理当前步骤失败，让当前状态决定如何恢复
     */
    failure(): Promise<void>;

    /**
     * 获取步骤信息
     */
    getStepInfo(): NoveltyCheckStepInfo;

    /**
     * 设置步骤状态
     * @param state 状态
     * @param status 状态
     */
    setStepStatus(state: NoveltyCheckReportState, status: NoveltyCheckStepInfoStatus): void;
}
